export default __webpack_public_path__ + "static/DharmaGothicE_Bold_R-2d0cd4d827d23794dcd9d6518543de31.otf";